import styled, { css } from 'styled-components';
import { transparentize } from 'polished';
import { colors } from '@keen.io/colors';
export var PropertyItem = styled.div.withConfig({
  displayName: "PropertyGroupstyles__PropertyItem",
  componentId: "keen-query-creator__sc-152bmll-0"
})(["&&&{height:100%;}"]);
export var Container = styled.div.withConfig({
  displayName: "PropertyGroupstyles__Container",
  componentId: "keen-query-creator__sc-152bmll-1"
})(["&&&{display:flex;background:", ";border-radius:4px;box-sizing:border-box;height:37px;transition:border-color 0.2s linear;", ";}&&& ", " + ", "{border-left:solid 1px ", ";}"], transparentize(0.85, colors.blue[100]), function (props) {
  return props.isActive && css(["box-shadow:0 0 3px 1px rgba(29,39,41,0.15);"]);
}, PropertyItem, PropertyItem, colors.white[500]);